import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { LoginPage } from '@/pages/LoginPage'
import { Dashboard } from '@/pages/Dashboard'
import { GeolocationPage } from '@/pages/GeolocationPage'
import { GeolocationListPage } from '@/pages/GeolocationListPage'
import { VisitoriaListPage } from '@/pages/VisitoriaListPage'
import { VisitoriaFormPage } from '@/pages/VisitoriaFormPage'
import { VisitoriaViewPage } from '@/pages/VisitoriaViewPage'
import { CalendariosListPage } from '@/pages/CalendariosListPage'
import { CalendarioFormPage } from '@/pages/CalendarioFormPage'
import { CardapiosListPage } from '@/pages/CardapiosListPage'
import { CardapioFormPage } from '@/pages/CardapioFormPage'
import ParametrosListPage from '@/pages/ParametrosListPage'
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage'
import { UsersListPage } from '@/pages/UsersListPage'
import { UserFormPage } from '@/pages/UserFormPage'
import { UserViewPage } from '@/pages/UserViewPage'
import { Layout } from '@/components/Layout'
import { ProtectedRoute } from '@/components/ProtectedRoute'

// Função para limpar tokens inválidos
function clearInvalidTokens() {
  localStorage.removeItem('auth_token')
  localStorage.removeItem('user_data')
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute permission="dashboard_view">
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/geolocation" 
            element={
              <ProtectedRoute permission="geolocation_create">
                <Layout>
                  <GeolocationPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/geolocations" 
            element={
              <ProtectedRoute permission="geolocation_view">
                <Layout>
                  <GeolocationListPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/vistorias" 
            element={
              <ProtectedRoute permission="vistoria_view">
                <Layout>
                  <VisitoriaListPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/vistorias/novo" 
            element={
              <ProtectedRoute permission="vistoria_create">
                <Layout>
                  <VisitoriaFormPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/vistorias/editar/:id" 
            element={
              <ProtectedRoute permission="vistoria_edit">
                <Layout>
                  <VisitoriaFormPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/vistorias/ver/:id" 
            element={
              <ProtectedRoute permission="vistoria_view">
                <Layout>
                  <VisitoriaViewPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/calendarios" 
            element={
              <ProtectedRoute permission="calendario_view">
                <Layout>
                  <CalendariosListPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/calendario/novo" 
            element={
              <ProtectedRoute permission="calendario_create">
                <Layout>
                  <CalendarioFormPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/calendarios/novo" 
            element={
              <ProtectedRoute permission="calendario_create">
                <Layout>
                  <CalendarioFormPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/calendarios/editar/:id" 
            element={
              <ProtectedRoute permission="calendario_edit">
                <Layout>
                  <CalendarioFormPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/cardapios" 
            element={
              <ProtectedRoute permission="cardapio_view">
                <Layout>
                  <CardapiosListPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/cardapio/novo" 
            element={
              <ProtectedRoute permission="cardapio_create">
                <Layout>
                  <CardapioFormPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/cardapios/novo" 
            element={
              <ProtectedRoute permission="cardapio_create">
                <Layout>
                  <CardapioFormPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/cardapios/editar/:id" 
            element={
              <ProtectedRoute permission="cardapio_edit">
                <Layout>
                  <CardapioFormPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/parametros" 
            element={
              <ProtectedRoute permission="parametro_view">
                <Layout>
                  <ParametrosListPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute permission="dashboard_view">
                <Layout>
                  <div className="max-w-4xl mx-auto px-4 text-center">
                    <h1 className="text-3xl font-bold text-slate-900 mb-4">
                      Dashboard
                    </h1>
                    <p className="text-slate-600 mb-8">
                      Bem-vindo ao sistema de carteiras e geolocalização
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      <a
                        href="/geolocation"
                        className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                      >
                        <h3 className="text-xl font-semibold text-slate-900 mb-2">
                          Nova Localização
                        </h3>
                        <p className="text-slate-600">
                          Cadastrar nova geolocalização
                        </p>
                      </a>
                      <a
                        href="/geolocations"
                        className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                      >
                        <h3 className="text-xl font-semibold text-slate-900 mb-2">
                          Listar Localizações
                        </h3>
                        <p className="text-slate-600">
                          Ver e gerenciar localizações cadastradas
                        </p>
                      </a>
                      <a
                        href="/vistorias"
                        className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                      >
                        <h3 className="text-xl font-semibold text-slate-900 mb-2">
                          Vistorias
                        </h3>
                        <p className="text-slate-600">
                          Ver e gerenciar vistorias do sistema
                        </p>
                      </a>
                      <a
                        href="/calendarios"
                        className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                      >
                        <h3 className="text-xl font-semibold text-slate-900 mb-2">
                          Calendários
                        </h3>
                        <p className="text-slate-600">
                          Ver e gerenciar calendários acadêmicos
                        </p>
                      </a>
                      <a
                        href="/cardapios"
                        className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                      >
                        <h3 className="text-xl font-semibold text-slate-900 mb-2">
                          Cardápios
                        </h3>
                        <p className="text-slate-600">
                          Ver e gerenciar cardápios e menus
                        </p>
                      </a>
                    </div>
                  </div>
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/usuarios" 
            element={
              <ProtectedRoute permission="user_view">
                <Layout>
                  <UsersListPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/usuarios/novo" 
            element={
              <ProtectedRoute permission="user_create">
                <Layout>
                  <UserFormPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/usuarios/editar/:id" 
            element={
              <ProtectedRoute permission="user_edit">
                <Layout>
                  <UserFormPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/usuarios/ver/:id" 
            element={
              <ProtectedRoute permission="user_view">
                <Layout>
                  <UserViewPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </div>
    </Router>
  )
}

export default App
